import { api } from "./api";

/**
 * Returns a list of errors
 * @returns {Promise<AxiosResponse<IErrorsAPI, any>>}
*/
export const getList = () => api.get('/errors')